import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// latex imports
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";

export const CreateQuestion = () => {
  let { id } = useParams();
  const location = useLocation();
  let { q, type, qp_id } = location.state;

  const macros = { "\\f": "#1f(#2)" };
  const opnArr = ['_', 'A', 'B', 'C', 'D']

  // hooks for question
  const [edit, setEdit] = useState(false);
  const [fetched, setFetched] = useState(true);
  const [ques, setQues] = useState("");
  const [quesImg, setQuesImg] = useState("");
  const [opn1, setOpn1] = useState("");
  const [opn1Img, setOpn1Img] = useState("");
  const [opn2, setOpn2] = useState("");
  const [opn2Img, setOpn2Img] = useState("");
  const [opn3, setOpn3] = useState("");
  const [opn3Img, setOpn3Img] = useState("");
  const [opn4, setOpn4] = useState("");
  const [opn4Img, setOpn4Img] = useState("");
  const [ans, setAns] = useState();
  const [ansImg, setAnsImg] = useState("");

  // useEffect

  useEffect(() => {
    console.log(type, q, qp_id);
    if (id) {
      setEdit(true);
      const tl = toast.loading("Please wait...");
      axios
        .get(`/${type}?id=${q.id}`)
        .then((res) => {
          toast.dismiss(tl);
          q = res.data;
          console.log(q.answer);
          setQues(q.question);
          setQuesImg(q.question_link);
          setOpn1(q.option1);
          setOpn1Img(q.option1_link);
          setOpn2(q.option2);
          setOpn2Img(q.option2_link);
          setOpn3(q.option3);
          setOpn3Img(q.option3_link);
          setOpn4(q.option4);
          setOpn4Img(q.option4_link);
          setAns(Number(q.answer));
          setAnsImg(q.answer_link);
        })
        .catch((er) => {
          toast.dismiss(tl);
          toast.error("Not Fetched");
        });
    }
  }, []);

  const handleEdit = () => {
    const tl = toast.loading("Editing ...");
    const data = {
      id: q.id,
      question: ques,
      qp_id: qp_id,
      question_link: quesImg,
      option1: opn1,
      option1_link: opn1Img,
      option2: opn2,
      option2_link: opn2Img,
      option3: opn3,
      option3_link: opn3Img,
      option4: opn4,
      option4_link: opn4Img,
      answer: Number(ans),
      answer_link: ansImg,
    };
    axios
      .put(`/${type}`, data)
      .then((res) => {
        toast.dismiss(tl);
        toast.success("Edited Successfully");
      })
      .catch((er) => {
        toast.dismiss(tl);
        toast.error("Internal Server Error");
      });
  };
  const handleSubmit = () => {
    const tl = toast.loading("Posting Question...");
    if (!ques || !opn1 || !opn2 || !opn3 || !opn3 || !opn4 || !ans) {
      toast.info("Required fields missing! Cannot post");
      return;
    }
    // backend dekh ke
    const data = {
      question: ques,
      qp_id: qp_id,
      question_link: quesImg,
      option1: opn1,
      option1_link: opn1Img,
      option2: opn2,
      option2_link: opn2Img,
      option3: opn3,
      option3_link: opn3Img,
      option4: opn4,
      option4_link: opn4Img,
      answer: Number(ans),
      answer_link: ansImg,
    };
    console.log(data);
    axios
      .post(`/${type}`, data)
      .then((res) => {
        toast.dismiss(tl);
        toast.info("Question posted!");
      })
      .catch((er) => {
        toast.dismiss(tl);
        toast.error("Internal Server Error");
      });
  };

  const imgUpload = (img, hook, prevUrl) => {
    const tl = toast.loading("Uploading image");
    const formData = new FormData();
    formData.append("file", img);
    formData.append("prevFile", prevUrl);
    axios
      .post("https://backend.tmesiitkgp.in/apptwo/uploadImage", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        toast.dismiss(tl);
        console.log(res.data, hook);
        switch (hook) {
          case "Question":
            setQuesImg(res.data.fileUrl);
            break;
          case "O1":
            console.log("Option 1 pe upload ho raha");
            setOpn1Img(res.data.fileUrl);
            break;
          case "O2":
            setOpn2Img(res.data.fileUrl);
            break;
          case "O3":
            setOpn3Img(res.data.fileUrl);
            break;
          case "O4":
            setOpn4Img(res.data.fileUrl);
            break;
          case "Ans":
            setAnsImg(res.data.fileUrl);
            break;
          default:
            break;
        }
      });
  };

  return (
    <>
      {fetched && (
        <div className="flex flex-row h-screen">
          {/* Left Section */}
          <div className="w-1/2 p-2 border-2 overflow-auto bg-[#EDF1D6]">
            <div class="p-2 rounded-lg">
              <p class="py-2 text-lg">Question text(Latex)</p>
              <textarea
                onChange={(e) => {
                  setQues(e.target.value);
                }}
                value={ques}
                class="w-full resize rounded-md bg-gray-100 border-blue-200 border-r-4"
              ></textarea>
              <div>
                <label
                  for="dropzone-file-ques"
                  class="flex h-20 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span class="font-semibold">Click to upload</span> or drag
                      and drop
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      SVG, PNG, JPG or GIF (MAX. 800x400px)
                    </p>
                  </div>
                  <input
                    id="dropzone-file-ques"
                    type="file"
                    class="hidden"
                    onChange={(e) =>
                      imgUpload(e.target.files[0], "Question", ques)
                    }
                  />
                </label>
              </div>
            </div>
            <div class="p-2 pt-6">
              <p class="py-2 text-slate-500">Option A(Latex)</p>
              <textarea
                onChange={(e) => {
                  setOpn1(e.target.value);
                }}
                value={opn1}
                class="w-full resize rounded-md bg-gray-100 border-blue-200 border-r-4"
              ></textarea>

              <div>
                <label
                  for="dropzone-file-o1"
                  class="flex h-20 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span class="font-semibold">Click to upload</span> or drag
                      and drop
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      SVG, PNG, JPG or GIF (MAX. 800x400px)
                    </p>
                  </div>
                  <input
                    id="dropzone-file-o1"
                    onChange={(e) => imgUpload(e.target.files[0], "O1", opn1)}
                    type="file"
                    class="hidden"
                  />
                </label>
              </div>
              <p class="py-2 text-slate-500">Option B(Latex)</p>
              <textarea
                onChange={(e) => {
                  setOpn2(e.target.value);
                }}
                value={opn2}
                class="w-full resize rounded-md bg-gray-100 border-blue-200 border-r-4"
              ></textarea>

              <div>
                <label
                  for="dropzone-file-o2"
                  class="flex h-20 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span class="font-semibold">Click to upload</span> or drag
                      and drop
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      SVG, PNG, JPG or GIF (MAX. 800x400px)
                    </p>
                  </div>
                  <input
                    id="dropzone-file-o2"
                    onChange={(e) => imgUpload(e.target.files[0], "O2", opn2)}
                    type="file"
                    class="hidden"
                  />
                </label>
              </div>
              <p class="py-2 text-slate-500">Option C(Latex)</p>
              <textarea
                onChange={(e) => {
                  setOpn3(e.target.value);
                }}
                value={opn3}
                class="w-full resize rounded-md bg-gray-100 border-blue-200 border-r-4"
              ></textarea>

              <div>
                <label
                  for="dropzone-file-o3"
                  class="flex h-20 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span class="font-semibold">Click to upload</span> or drag
                      and drop
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      SVG, PNG, JPG or GIF (MAX. 800x400px)
                    </p>
                  </div>
                  <input
                    id="dropzone-file-o3"
                    onChange={(e) => imgUpload(e.target.files[0], "O3", opn3)}
                    type="file"
                    class="hidden"
                  />
                </label>
              </div>
              <p class="py-2 text-slate-500">Option D(Latex)</p>
              <textarea
                onChange={(e) => {
                  setOpn4(e.target.value);
                }}
                value={opn4}
                class="w-full resize rounded-md bg-gray-100 border-blue-200 border-r-4"
              ></textarea>

              <div>
                <label
                  for="dropzone-file-o4"
                  class="flex h-20 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span class="font-semibold">Click to upload</span> or drag
                      and drop
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      SVG, PNG, JPG or GIF (MAX. 800x400px)
                    </p>
                  </div>
                  <input
                    id="dropzone-file-o4"
                    onChange={(e) => imgUpload(e.target.files[0], "O4", opn4)}
                    type="file"
                    class="hidden"
                  />
                </label>
              </div>
            </div>
            <div class="p-2">
              <p class="py-2 text-slate-500">Answer</p>
              <select
                id="small"
                value={ans}
                onChange={(e) => {
                  setAns(Number(e.target.value));
                }}
                className="mb-6 block w-full rounded-lg border border-gray-300 bg-gray-50 p-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
              >
                <option selected>Choose type</option>
                <option value={1}>A</option>
                <option value={2}>B</option>
                <option value={3}>C</option>
                <option value={4}>D</option>
              </select>

              <div>
                <label
                  for="dropzone-file-ans"
                  class="flex h-20 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span class="font-semibold">Click to upload</span> or drag
                      and drop
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      SVG, PNG, JPG or GIF (MAX. 800x400px)
                    </p>
                  </div>
                  <input
                    id="dropzone-file-ans"
                    onChange={(e) => imgUpload(e.target.files[0], "Ans", ans)}
                    type="file"
                    class="hidden"
                  />
                </label>
              </div>
            </div>
            {!edit ? (
              <>
                <button
                  onClick={handleSubmit}
                  className="text-xl my-4 bg-[#3F72AF] rounded-lg p-2 text-white font-semibold"
                >
                  Create Question
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={handleEdit}
                  className="text-xl my-4 bg-lime-500 rounded-lg p-2 text-white font-semibold"
                >
                  Update Question
                </button>
              </>
            )}
          </div>
          {/* /
                /
                /
                /
                / */}
          {/* Right Section */}
          <div className="min-h-full w-1/2 overflow-auto bg-slate-100 p-2">
            <p className="text-2xl font-semibold p-4">Rendered Question</p>
            <div class="mb-4">
              {ques && (
                <>
                  <p class="text-xl text-gray-900 ml-2 block">
                    <Latex macros={macros}>{ques}</Latex>
                  </p>
                </>
              )}
              {quesImg ? <img src={quesImg}></img> : null}
            </div>
            <div class="mb-4">
              <span className="font-medium text-lg">A. </span>
              {opn1 && (
                <>
                  <Latex macros={macros}>{opn1}</Latex>
                </>
              )}
              {opn1Img ? <img src={opn1Img}></img> : null}
            </div>
            <div class="mb-4">
              <span className="font-medium text-lg">B. </span>
              {opn2 && (
                <>
                  <Latex macros={macros}>{opn2}</Latex>
                </>
              )}
              {opn2Img ? <img src={opn2Img}></img> : null}
            </div>
            <div class="mb-4">
              <span className="font-medium text-lg">C. </span>
              {opn3 && (
                <>
                  <Latex macros={macros}>{opn3}</Latex>
                </>
              )}
              {opn3Img ? <img src={opn3Img}></img> : null}
            </div>
            <div class="mb-4">
              <span className="font-medium text-lg">D. </span>
              {opn4 && (
                <>
                  <Latex macros={macros}>{opn4}</Latex>
                </>
              )}
              {opn4Img ? <img src={opn4Img}></img> : null}
            </div>
            <div class="mb-4">
              {ans && (
                <>
                  <p
                    for="country-option-1"
                    class="text-lg font-light ml-2 block"
                  >
                    <span className="text-lg text-lime-700">
                      Ans: <span className="font-medium mx-1 ">{opnArr[ans]}</span>
                    </span>
                  </p>
                </>
              )}
              {ansImg ? <img src={ansImg}></img> : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
